import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert, Button, Card, CardContent, FormControlLabel, Stack, Switch, Typography } from '@mui/material'
import organizationSessionStore from '../../../stores/organizationSessionStore'
import organizationProfileStore from '../../../stores/organizationProfileStore'

const RequireClientPolicySettings = observer(() => {
	const context = organizationSessionStore.currentContext
	const policy = Boolean(context?.policies?.requireClientOnRequestCreation)
	const [required, setRequired] = useState(policy)
	const canEdit = context?.organization?.kind === 'TEAM'
		&& ['OWNER', 'ADMIN'].includes(context?.membership?.role)

	useEffect(() => { setRequired(policy) }, [policy])

	if (!context?.policies) return null
	const save = async () => {
		await organizationProfileStore.updateVisibilityPolicies({ requireClientOnRequestCreation: required })
	}

	return <Card variant='outlined' sx={{ m: 2 }}>
		<CardContent>
			<Stack spacing={1.5}>
				<Typography variant='h6'>Заявки и клиенты</Typography>
				<FormControlLabel
					control={<Switch checked={required} onChange={event => setRequired(event.target.checked)} disabled={!canEdit || organizationProfileStore.saving} />}
					label='Требовать клиента при создании заявки'
				/>
				<Typography color='text.secondary'>Если включено, новую заявку нельзя создать без выбранного или нового клиента.</Typography>
				{organizationProfileStore.error && <Alert severity='error'>{organizationProfileStore.error}</Alert>}
				{canEdit
					? <Button variant='contained' onClick={save} disabled={organizationProfileStore.saving || required === policy}>Сохранить</Button>
					: <Typography variant='body2' color='text.secondary'>Изменять правило могут владелец и администратор организации.</Typography>}
			</Stack>
		</CardContent>
	</Card>
})

export default RequireClientPolicySettings
